import '../legacy/bundles/vendorBundle';

/** shim over BigScreen library to let us know if we can use full screen mode */
export abstract class FullScreenService {
	static isEnabled(): boolean {
		return window.BigScreen.enabled;
	}
}
